import React, {
	createContext,
	useCallback,
	useContext,
	useMemo,
	useState,
} from "react";

const StudentContext =
	createContext(null);

export const StudentProvider = ({
	children,
}) => {
	const [chapter,setChapter] =useState(null);
	const [resource,setResource] = useState(null);
	const [navigationChapter, setNavigationChapterState] = useState(null);

	const setNavigationChapter = useCallback((chapterData) => {
		if (!chapterData) {
			setNavigationChapterState(null);
			return;
		}

		if (!chapterData?.chapterId) return;

		setNavigationChapterState({
			chapterId: chapterData.chapterId,
			chapterName: chapterData.chapterName || "",
		});
	}, []);

	const value = useMemo( () => ({ 
			chapter,
			setChapter,
			resource,
			setResource,
			navigationChapter,
			setNavigationChapter,
		}),
		[chapter, resource, navigationChapter, setNavigationChapter]
	);

	return (
		<StudentContext.Provider
			value={value}
		>
			{children}
		</StudentContext.Provider>
	);
};

export const useStudent = () => {
    const context = useContext( StudentContext );
    if (!context) {
      throw new Error(
        "useStudent must be used inside StudentProvider"
      );
    }
    return context;
  };
